import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from "../../config/axiosInstance";

// ---------------------category-listing--------------------------
export const subCategoryListApi1 = async (data) => {
  console.log('data subCategoryListApi', data)
  const params = new URLSearchParams();

  // Add static/default params
  params.append("search", "");
  params.append("status", "");
  params.append("page", 1);
  params.append("limit", data.limit || 100);

  // Add multiple subcategories
  if (data.category && Array.isArray(data.category)) {
    console.log('callllll-------->')
    data.category.forEach((id) => {
      console.log('id---------@@@@', id)
      params.append("category", id);
    });
  }
  // const endPoint = `/admin/subcategories?${params.toString()})}`;
  const endPoint = `/admin/subcategories?${params.toString()}`;

  return await axios.get(endPoint, setJwtToken());
};

export const subCategoryListApi = async (data = {}) => {
  const params = new URLSearchParams();

  // dynamic params
  if (data.search) params.append("search", data.search);
  if (data.status) params.append("status", data.status);
  if (data.page) params.append("page", data.page);
  if (data.limit) params.append("limit", data.limit);

  // multiple category support
  if (data.category && Array.isArray(data.category)) {
    data.category.forEach((id) => {
      params.append("category", id);
    });
  }

  const endPoint = `/admin/subcategories?${params.toString()}`;
  return await axios.get(endPoint, setJwtToken());
};


// --------------post sub category

export const addSubCategoryApi = async (data) => {
  const endPoint = `/admin/subcategories`;

  return await axios.post(endPoint, data, setJwtToken());
};

// ------------------master data from sub Category

export const subCategoryMasterApi = async (data) => {
  const endPoint = `/admin/master/getAllMasterData?${new URLSearchParams({
    ...data,
  })}`;

  return await axios.get(endPoint, setJwtToken());
};

// ------fetch subcategory detail

export const subCategoryListApiDetail = async (id) => {
  const endPoint = `/admin/subcategories/${id}`;

  return await axios.get(endPoint, setJwtToken());
};

// ------update detail
export const subCategoryUpdateApiDetail = async ({ data, id }) => {
  const endPoint = `/admin/subcategories/${id}`;

  return await axios.put(endPoint, data, setJwtToken());
};

// -------delete sub Category

export const subCategoryDeleteApi = async (id) => {
  const endPoint = `/admin/subcategories/${id}`;

  return await axios.delete(endPoint, setJwtToken());
};

// -------delete sub Category

export const subCategoryStatusApi = async ({ id, status }) => {
  const endPoint = `/admin/subcategories/${id}`;

  return await axios.patch(endPoint, { status }, setJwtToken());
};


// ----------------------------SUB-SUB-CATEGORY-APIS---------------------------------------------

// --------------------sub-sub-category-listing--------------------------
export const subSubCategoryListApi = async (data) => {
  const params = new URLSearchParams();

  // Add static/default params
  params.append("search", "");
  params.append("status", "");
  params.append("page", 1);
  params.append("limit", data.limit || 100);

  // Add multiple subcategories
  if (data.subcategories && Array.isArray(data.subcategories)) {
    data.subcategories.forEach((id) => {
      params.append("category", id);
    });
  }
  const endPoint = `/admin/subsubcategories?${new URLSearchParams({ ...data, })}`;
  return await axios.get(endPoint, setJwtToken());
};
// ----------add-sub-Sub-category----------------
export const addSubSubCategoryApi = async (data) => {
  const endPoint = `/admin/subsubcategories`;
  return await axios.post(endPoint, data, setJwtToken());
};
// ----------update-sub-Sub-category----------------
export const updateSubSubCategoryApi = async (id, data) => {
  const endPoint = `/admin/subsubcategories/${id}`;
  return await axios.put(endPoint, data, setJwtToken());
};
// ----------change-status-----------------
export const changeStatusSubSubCategoryApi = async ({ id, status }) => {
  const endPoint = `/admin/subsubcategories/${id}`;
  return await axios.patch(endPoint, { status }, setJwtToken());
};
// -----------------delete-----------------
export const deleteSubSubCategoryApi = async (id) => {
  const endPoint = `/admin/subsubcategories/${id}`;
  return await axios.delete(endPoint, setJwtToken());
};

// --------------------sub-sub-category-listing--------------------------
export const multiSubSubCategoryListApi = async (data) => {
  // console.log('data subSubCategoryListApi', data);

  const params = new URLSearchParams();

  // Add static/default params
  params.append("search", "");
  params.append("status", "");
  params.append("page", 1);
  params.append("limit", data.limit || 100);

  // Add multiple subcategories
  if (data.subcategories && Array.isArray(data.subcategories)) {
    data.subcategories.forEach((id) => {
      params.append("subcategory", id);
    });
  }

  const endPoint = `/admin/subsubcategories?${params.toString()}`;
  return await axios.get(endPoint, setJwtToken());
};


